import { useState } from "react";

const statusCodes = {
    AWAITING_USER_INPUT: 1,
    SAVING: 2,
    DONE: 3
};

export const useFormStatus = (initialStatus = statusCodes.AWAITING_USER_INPUT) => {
    let [status, setStatus] = useState(initialStatus);

    return [status, setStatus, statusCodes];
}